module.exports = __webpack_public_path__ + "static/img/pcmap.450c8a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pcmap.png
// module id = AXnE
// module chunks = 45